export default __webpack_public_path__ + "static/media/fog.7541ab92.svg";